import React from 'react';

const AudioTimer = ({ isRunning, setIsRunning, elapsedTime, setElapsedTime }) => {
    React.useEffect(() => {
        let intervalId;
        if (isRunning) {
            intervalId = setInterval(() => {
                if (elapsedTime > 0) {
                    setElapsedTime(elapsedTime - 1);
                } else {
                    clearInterval(intervalId);
                    setIsRunning(false);
                }
            }, 10);
        }
        return () => clearInterval(intervalId);
    }, [isRunning, elapsedTime, setElapsedTime, setIsRunning]);

    const hours = Math.floor(elapsedTime / 360000);
    const minutes = Math.floor((elapsedTime % 360000) / 6000);
    const seconds = Math.floor((elapsedTime % 6000) / 100);
    const milliseconds = elapsedTime % 100;

    return (
        <div className="font-semibold">
            <div className="time">
                {minutes.toString().padStart(2, "0")}:
                <span className="inline-block"> {seconds.toString().padStart(2, "0")}</span>
                {/* <span className=" w-[23px] inline-block">{milliseconds.toString().padStart(2, "0")}</span> */}
            </div>
        </div>
    );
};

export default AudioTimer;
